var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "filter-select",
      class: { "filter-select--active": this.value }
    },
    [
      _c(
        "label",
        {
          staticClass: "filter-select__label",
          class: { "sr-only": !this.value },
          attrs: { for: _vm.label }
        },
        [_vm._v(_vm._s(_vm.label))]
      ),
      _vm._v(" "),
      _vm.icon
        ? _c("div", [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: _vm.icon.width,
                  height: _vm.icon.height,
                  viewBox: _vm.icon.viewBox
                }
              },
              [_c("use", { attrs: { href: _vm.icon.url } })]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "select",
        {
          ref: "filterSelectInput",
          staticClass: "filter-select__input",
          attrs: { id: _vm.label, name: _vm.label },
          domProps: { value: _vm.value },
          on: {
            input: function($event) {
              return _vm.emitValue($event.target.value)
            }
          }
        },
        [
          _c("option", { attrs: { value: "" } }, [
            _vm._v("\n      " + _vm._s(_vm.label) + "\n    ")
          ]),
          _vm._v(" "),
          _vm._l(_vm.options, function(item, index) {
            return _c(
              "option",
              {
                key: _vm.label + "-" + index,
                domProps: { value: _vm.useValue ? item.Id : item.Name }
              },
              [_vm._v("\n      " + _vm._s(item.Name) + "\n    ")]
            )
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }